import { useMemo, useState } from "react";
import { RequisitionResponse } from "../../types/model/warehouse/requisition";

export const useRequisitionSearch = (data: RequisitionResponse[], onChange?: () => void) => {
  const [search, setSearchValue] = useState("");

  const filteredData = useMemo(() => {
    const term = search.toLowerCase();
    if (!term) return data;

    const matches = (value?: string | null) => value?.toLowerCase().includes(term);

    return data.filter(
      (item) =>
        matches(item.requestedByName) ||
        matches(item.accountName) ||
        item.equipment.some((e) => matches(e.equipmentType) || matches(e.equipmentModel) || matches(e.serialNumber)),
    );
  }, [data, search]);

  const setSearch = (value: string) => {
    setSearchValue(value);
    onChange?.();
  };

  return { search, setSearch, filteredData };
};